/**
 * TokenCounter — Contador de tokens in/out por mensagem
 */
import { h } from 'preact';

export interface TokenCounterProps {
  tokensIn: number;
  tokensOut: number;
  costUsd?: number;
  durationMs?: number;
}

export function TokenCounter({ tokensIn, tokensOut, costUsd, durationMs }: TokenCounterProps) {
  const parts = [`${tokensIn}+${tokensOut} tokens`];
  if (costUsd !== undefined) parts.push(`$${costUsd.toFixed(4)}`);
  if (durationMs !== undefined) parts.push(`${(durationMs / 1000).toFixed(1)}s`);

  return (
    <span style={{ fontSize: 9, opacity: 0.6, fontFamily: 'monospace' }}>
      {parts.join(' · ')}
    </span>
  );
}
